// © Microsoft Corporation. All rights reserved.

/** Git configs flight treatment t with IndexedDB */
export const gitConfigsTreatmentWithIdb = "prg-gitconfigs-t";

/** Git configs flight treatment t1 without IndexedDB */
export const gitConfigsTreatmentWithoutIdb = "prg-gitconfigs-t1";

/** Git configs flight treatment t11 without IndexedDB */
export const gitConfigsTreatment1WithoutIdb = "prg-gitconfigs-t11";

/**
 * Constants used for client resolver
 */
// fetch type constants
export const featureManifests = "feature-manifests";
export const localizationManifests = "loc-manifests";

export const featureConfigs = "feature-configs";
export const localizationConfigs = "loc-configs";

// instance constants
export const defaultInstance = "default";

/**
 * Constants used for config caching
 */
export namespace ConfigCachingConstants {
    /** IndexedDB store */
    export const idbStoreName = "Configurations_12";

    /** IndexedDB name */
    export const idbName = "wwConfigs";

    /** Config staleness duration.
     * This is used by IndexedDB at client and ServerCache at SSR.
     * 604800000 = 7 days in milliseconds
     */
    export const configStalenessDuration = 604800000;

    /**
     * Default max of server side resolver's in-memory config cache.
     */
    export const serverLruConfigCacheMax = 10240;

    /** Idb config read promise name */
    export const idbInitPromiseNameKey = "initializeIdbKey";

    /** Idb config read promise name */
    export const idbReadPromiseNameKey = "readConfigsFromIdbKey";

    /** Idb config write promise name */
    export const idbWritePromiseNameKey = "writeConfigsToIndexedDbKey";
}